import { render, staticRenderFns } from "./applicationsList.vue?vue&type=template&id=20ca9ede&scoped=true"
import script from "./applicationsList.vue?vue&type=script&lang=js"
export * from "./applicationsList.vue?vue&type=script&lang=js"
import style0 from "./applicationsList.vue?vue&type=style&index=0&id=20ca9ede&prod&scoped=true&lang=scss"
import style1 from "./applicationsList.vue?vue&type=style&index=1&id=20ca9ede&prod&lang=scss"
import style2 from "./applicationsList.vue?vue&type=style&index=2&id=20ca9ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ca9ede",
  null
  
)

export default component.exports